import { render, staticRenderFns } from "./AddonProduktionsVerfahrenSelect.vue?vue&type=template&id=639e31b0"
import script from "./AddonProduktionsVerfahrenSelect.vue?vue&type=script&lang=js"
export * from "./AddonProduktionsVerfahrenSelect.vue?vue&type=script&lang=js"
import style0 from "./AddonProduktionsVerfahrenSelect.vue?vue&type=style&index=0&id=639e31b0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports